/**
 * MAISON NOIRE - Givenchy-Inspired Shopify Theme
 * Main JavaScript
 */

(function() {
  'use strict';

  /* ===========================
     GLOBAL CART HELPERS (outside init — always available)
     Uses Shopify Section Rendering API for cart drawer refresh
     =========================== */
  window.MaisonNoire = window.MaisonNoire || {};

  function t(key, fallback) {
    var strings = (window.theme && window.theme.strings) || {};
    return strings[key] || fallback;
  }

  function getRoutes() {
    return (window.theme && window.theme.routes) || {
      cart_url: '/cart',
      cart_add_url: '/cart/add',
      cart_change_url: '/cart/change',
      search_url: '/search'
    };
  }

  /**
   * Refresh cart drawer HTML via Section Rendering API
   * Fetches fresh server-rendered HTML and replaces drawer content
   */
  function refreshCartDrawer() {
    var routes = getRoutes();
    return fetch(routes.cart_url + '?sections=cart-drawer')
      .then(function(res) { return res.json(); })
      .then(function(sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-cart-drawer-inner]');
        var currentInner = document.querySelector('[data-cart-drawer-inner]');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
      })
      .catch(function(err) {
        console.error('Cart drawer refresh error:', err);
      });
  }

  /**
   * Update cart count badges in header
   */
  function updateCartCount() {
    var routes = getRoutes();
    return fetch(routes.cart_url + '.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        return cart;
      });
  }

  /**
   * Open cart drawer
   */
  function openCartDrawer() {
    var drawer = document.querySelector('.cart-drawer');
    var ov = document.querySelector('[data-overlay]');
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (ov) ov.classList.add('is-active');
    }
  }

  /**
   * Close cart drawer
   */
  function closeCartDrawer() {
    var drawer = document.querySelector('.cart-drawer');
    var ov = document.querySelector('[data-overlay]');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (ov) ov.classList.remove('is-active');
    }
  }

  /**
   * Add items to cart, refresh drawer, open it
   */
  window.MaisonNoire.addToCart = function(variantId, quantity) {
    quantity = quantity || 1;
    var routes = getRoutes();
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        // Shopify returned an error (e.g. variant not found)
        console.error('Add to cart error:', data.description);
        return data;
      }
      // Check cart type: redirect to page or open drawer
      if (window.theme && window.theme.cartType === 'page') {
        window.location.href = '/cart';
        return data;
      }
      return Promise.all([refreshCartDrawer(), updateCartCount()])
        .then(function() {
          openCartDrawer();
          return data;
        });
    });
  };

  /**
   * Refresh cart page HTML via Section Rendering API
   * Used when +/- or remove is clicked on /cart page
   */
  function refreshCartPage() {
    var cartSection = document.querySelector('.cart-page');
    if (!cartSection) return Promise.resolve();
    var sectionEl = cartSection.closest('[id^="shopify-section-"]');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    if (!sectionId) return Promise.resolve();
    cartSection.style.opacity = '0.5';
    cartSection.style.pointerEvents = 'none';
    return fetch('/cart?sections=' + sectionId)
      .then(function(res) { return res.json(); })
      .then(function(sections) {
        var html = sections[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('.cart-page');
        if (newSection) {
          cartSection.innerHTML = newSection.innerHTML;
        }
      })
      .catch(function(err) {
        console.error('Cart page refresh error:', err);
      })
      .finally(function() {
        cartSection.style.opacity = '';
        cartSection.style.pointerEvents = '';
      });
  }

  window.MaisonNoire.changeCart = function(key, quantity) {
    var routes = getRoutes();
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      return Promise.all([refreshCartDrawer(), refreshCartPage(), updateCartCount()])
        .then(function() { return cart; });
    });
  };

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-key');
    var qty = parseInt(btn.getAttribute('data-qty'));
    if (!key || isNaN(qty)) return;
    window.MaisonNoire.changeCart(key, qty);
  });

  /* ===========================
     BUNDLE OFFER — ADD PACK (outside init for reliability)
     =========================== */
  function getBundleVariantId(productNum) {
    var variantsEl = document.querySelector('[data-bundle-variants-' + productNum + ']');
    if (!variantsEl) return null;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return null; }
    var selects = document.querySelectorAll('.bundle-variant-select[data-bundle-product="' + productNum + '"]');
    if (!selects.length) return null;
    var selectedOptions = [];
    selects.forEach(function(sel) { selectedOptions.push(sel.value); });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (v.options[j] !== selectedOptions[j]) { match = false; break; }
      }
      if (match) return v.id;
    }
    return null;
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    e.preventDefault();

    var items = [];

    // Product 1 — bundle selects > main variant picker > button default
    var p1Id = getBundleVariantId('1');
    if (!p1Id) {
      var mainInput = document.querySelector('[data-variant-id]');
      p1Id = mainInput ? parseInt(mainInput.value) : null;
    }
    if (!p1Id) p1Id = parseInt(btn.getAttribute('data-product1-id'));
    if (p1Id && !isNaN(p1Id)) items.push({ id: p1Id, quantity: 1 });

    // Product 2
    var p2Attr = btn.getAttribute('data-product2-default');
    if (p2Attr) {
      var p2Id = getBundleVariantId('2');
      if (!p2Id) p2Id = parseInt(p2Attr);
      if (p2Id && !isNaN(p2Id)) items.push({ id: p2Id, quantity: 1 });
    }

    // Product 3
    var p3Attr = btn.getAttribute('data-product3-default');
    if (p3Attr) {
      var p3Id = getBundleVariantId('3');
      if (!p3Id) p3Id = parseInt(p3Attr);
      if (p3Id && !isNaN(p3Id)) items.push({ id: p3Id, quantity: 1 });
    }

    if (!items.length) {
      console.warn('Bundle: no items to add', btn.dataset);
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = t('adding', 'Adding...');

    var routes = getRoutes();
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        console.error('Bundle add error:', data.description);
        btn.disabled = false;
        btn.textContent = originalText;
        return;
      }
      btn.textContent = t('added', 'Added');
      if (window.theme && window.theme.cartType === 'page') {
        window.location.href = '/cart';
        return;
      }
      return Promise.all([refreshCartDrawer(), updateCartCount()])
        .then(function() {
          openCartDrawer();
          setTimeout(function() {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1500);
        });
    })
    .catch(function(err) {
      console.error('Bundle add error:', err);
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });

  /* ===========================
     INIT — DOM-dependent setup
     =========================== */
  function init() {

  /* ===========================
     HEADER & SCROLL
     =========================== */
  var header = document.querySelector('.site-header');
  var announcementBar = document.querySelector('.announcement-bar');
  var lastScroll = 0;

  // Set announcement bar + header height as CSS variables
  function updateLayoutHeights() {
    if (announcementBar) {
      var ah = announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', ah + 'px');
    }
    if (header) {
      var hh = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', hh + 'px');
    }
  }
  updateLayoutHeights();
  window.addEventListener('resize', updateLayoutHeights);

  function handleScroll() {
    var scrollY = window.scrollY;

    if (header) {
      if (scrollY > 50) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }

      if (announcementBar) {
        if (scrollY > 100) {
          announcementBar.style.transform = 'translateY(-100%)';
          header.classList.remove('has-announcement');
        } else {
          announcementBar.style.transform = 'translateY(0)';
          header.classList.add('has-announcement');
        }
      }
    }

    lastScroll = scrollY;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  /* ===========================
     MOBILE NAVIGATION
     =========================== */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('[data-mobile-close]');
  var overlay = document.querySelector('[data-overlay]');

  function openMobileNav() {
    if (mobileNav) {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (overlay) overlay.classList.add('is-active');
    }
  }

  function closeMobileNav() {
    if (mobileNav) {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
      if (overlay) overlay.classList.remove('is-active');
    }
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
  if (overlay) overlay.addEventListener('click', function() {
    closeMobileNav();
    closeCartDrawer();
    closeSearch();
  });

  /* ===========================
     CART DRAWER TOGGLE
     =========================== */
  var cartToggle = document.querySelectorAll('[data-cart-toggle]');

  cartToggle.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.theme && window.theme.cartType === 'page') {
        window.location.href = '/cart';
        return;
      }
      openCartDrawer();
    });
  });

  // Close button uses event delegation (works after section re-render)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-close]')) {
      closeCartDrawer();
    }
  });

  /* ===========================
     SEARCH OVERLAY
     =========================== */
  var searchOverlay = document.querySelector('.search-overlay');
  var searchToggle = document.querySelectorAll('[data-search-toggle]');
  var searchClose = document.querySelector('[data-search-close]');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var input = searchOverlay.querySelector('input');
      if (input) setTimeout(function() { input.focus(); }, 300);
    }
  }

  function closeSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  searchToggle.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });
  });

  if (searchClose) searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeCartDrawer();
      closeMobileNav();
    }
  });

  /* ===========================
     PRODUCT ACCORDIONS (event delegation)
     =========================== */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.product-accordion__trigger');
    if (!trigger) return;
    var item = trigger.closest('.product-accordion__item');
    if (!item) return;
    var content = item.querySelector('.product-accordion__content');
    var inner = content ? content.querySelector('.product-accordion__content-inner') : null;
    if (!content || !inner) return;

    if (item.classList.contains('is-open')) {
      content.style.maxHeight = '0';
      item.classList.remove('is-open');
    } else {
      content.style.maxHeight = inner.scrollHeight + 'px';
      item.classList.add('is-open');
    }
  });

  /* ===========================
     MOBILE SWIPE GALLERY
     =========================== */
  (function() {
    var swipe = document.querySelector('[data-gallery-swipe]');
    if (!swipe) return;

    var dots = document.querySelectorAll('.product-gallery__dot');
    var counter = document.querySelector('[data-current-slide]');
    var slideCount = swipe.children.length;
    var currentIndex = 0;

    function goToSlide(index) {
      if (index < 0) index = 0;
      if (index >= slideCount) index = slideCount - 1;
      currentIndex = index;
      var slideWidth = swipe.children[0].offsetWidth;
      swipe.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
      updateIndicators();
    }

    function updateIndicators() {
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === currentIndex);
      });
      if (counter) counter.textContent = currentIndex + 1;
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.getAttribute('data-dot-index')));
      });
    });


// Disable browser scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Aggressively keep gallery on slide 1 until user interacts
    var userHasScrolled = false;

    function forceFirst() {
      if (userHasScrolled) return;
      swipe.scrollLeft = 0;
      currentIndex = 0;
      updateIndicators();
    }

    // Use a scroll guard — any scroll not initiated by user gets corrected
    var guardInterval = setInterval(forceFirst, 80);

    // Stop guarding after user touches the gallery or after 1.5 seconds
    function stopGuard() {
      userHasScrolled = true;
      clearInterval(guardInterval);
    }

    swipe.addEventListener('touchstart', stopGuard, { once: true, passive: true });
    setTimeout(stopGuard, 1500);

    // Back/forward navigation (bfcache)
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) {
        userHasScrolled = false;
        guardInterval = setInterval(forceFirst, 50);
        swipe.addEventListener('touchstart', stopGuard, { once: true, passive: true });
        setTimeout(stopGuard, 1500);
      }
    });

    var scrollTimeout;
    swipe.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var slideWidth = swipe.children[0] ? swipe.children[0].offsetWidth : 0;
        if (slideWidth === 0) return;
        var newIndex = Math.round(swipe.scrollLeft / slideWidth);
        if (newIndex < 0) newIndex = 0;
        if (newIndex >= slideCount) newIndex = slideCount - 1;
        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          updateIndicators();
        }
      }, 10);
    }, { passive: true });
  })();

  /* ===========================
     ADVANCED VARIANT PICKER (event delegation)
     =========================== */
  function getVariantForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantSelect() {
    var form = getVariantForm();
    return form ? form.querySelector('[data-variant-select]') : null;
  }

  function getSelectedOptions() {
    var form = getVariantForm();
    if (!form) return [];
    var options = [];
    form.querySelectorAll('.variant-picker').forEach(function(picker) {
      var index = parseInt(picker.getAttribute('data-option-index'));
      var active = picker.querySelector('.variant-picker__option.is-active, .variant-swatch.is-active');
      if (active) {
        options[index] = active.getAttribute('data-value');
        return;
      }
      var dropdownActive = picker.querySelector('.variant-dropdown__option.is-active');
      if (dropdownActive) {
        options[index] = dropdownActive.getAttribute('data-value');
      }
    });
    return options;
  }

  function updateVariant() {
    var form = getVariantForm();
    var variantSelect = getVariantSelect();
    if (!form || !variantSelect) return;

    var selected = getSelectedOptions();
    var matched = null;
    for (var i = 0; i < variantSelect.options.length; i++) {
      var opt = variantSelect.options[i];
      var match = true;
      selected.forEach(function(val, idx) {
        if (val && opt.getAttribute('data-option' + (idx + 1)) !== val) {
          match = false;
        }
      });
      if (match) { matched = opt; break; }
    }

    if (matched) {
      variantSelect.value = matched.value;
      variantSelect.dispatchEvent(new Event('change'));
      // Update price
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) {
        var hasCompare = parseInt(matched.getAttribute('data-has-compare')) > 0;
        if (hasCompare) {
          priceEl.innerHTML = '<span class="product-card__price--compare">' + matched.getAttribute('data-compare-price') + '</span> <span class="product-card__price--sale">' + matched.getAttribute('data-price') + '</span>';
        } else {
          priceEl.innerHTML = matched.getAttribute('data-price');
        }
        // Update save badge (outside price div)
        var badgeEl = document.querySelector('[data-save-badge]');
        if (badgeEl) {
          if (hasCompare) {
            var comparePrice = parseInt(matched.getAttribute('data-has-compare'));
            var currentPrice = parseInt(matched.value ? matched.getAttribute('data-has-compare') : 0);
            // Parse price from formatted string
            var priceRaw = matched.getAttribute('data-price').replace(/[^0-9]/g, '');
            currentPrice = parseInt(priceRaw) || 0;
            var savedPercent = Math.round((comparePrice - currentPrice) / comparePrice * 100);
            var template = badgeEl.getAttribute('data-template') || '';
            badgeEl.textContent = template ? template.replace('[percent]', savedPercent) : savedPercent + '%';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
      }
      // Update button
      var btn = document.querySelector('[data-add-to-cart]');
      if (btn) {
        var avail = matched.getAttribute('data-available') === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? (btn.getAttribute('data-add-text') || t('addToCart', 'Add to Bag')) : t('soldOut', 'Sold Out');
      }
      // Update URL
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', matched.value);
        window.history.replaceState({}, '', url.toString());
      }

      // Switch gallery to variant image
      var imageId = matched.getAttribute('data-image-id');
      if (imageId) {
        // Desktop: scroll the matching image into view
        var desktopImg = document.querySelector('.product-gallery--desktop [data-image-id="' + imageId + '"]');
        if (desktopImg) {
          desktopImg.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        // Mobile: swipe to the matching slide
        var swipe = document.querySelector('[data-gallery-swipe]');
        if (swipe) {
          var slides = swipe.querySelectorAll('[data-image-id]');
          for (var si = 0; si < slides.length; si++) {
            if (slides[si].getAttribute('data-image-id') === imageId) {
              var slideWidth = slides[si].offsetWidth;
              swipe.scrollTo({ left: slideWidth * si, behavior: 'smooth' });
              // Update dots & counter
              var dots = document.querySelectorAll('.product-gallery__dot');
              dots.forEach(function(d, di) {
                d.classList.toggle('is-active', di === si);
              });
              var counter = document.querySelector('[data-current-slide]');
              if (counter) counter.textContent = si + 1;
              break;
            }
          }
        }
      }
    }
  }

  // Button/swatch clicks (delegated)
  document.addEventListener('click', function(e) {
    var el = e.target.closest('.variant-picker__option, .variant-swatch');
    if (!el) return;
    var picker = el.closest('.variant-picker');
    if (!picker) return;
    picker.querySelectorAll('.variant-picker__option, .variant-swatch').forEach(function(o) {
      o.classList.remove('is-active');
    });
    el.classList.add('is-active');
    var label = picker.querySelector('[data-selected-value]');
    if (label) label.textContent = el.getAttribute('data-value');
    updateVariant();
  });

  // Dropdown toggle (delegated)
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-dropdown-trigger]');
    if (trigger) {
      e.preventDefault();
      var dropdown = trigger.closest('.variant-dropdown');
      if (!dropdown) return;
      dropdown.classList.toggle('is-open');
      document.querySelectorAll('.variant-dropdown').forEach(function(d) {
        if (d !== dropdown) d.classList.remove('is-open');
      });
      return;
    }

    var opt = e.target.closest('.variant-dropdown__option');
    if (opt) {
      e.preventDefault();
      var dropdown = opt.closest('.variant-dropdown');
      var picker = opt.closest('.variant-picker');
      if (dropdown) {
        dropdown.querySelectorAll('.variant-dropdown__option').forEach(function(o) {
          o.classList.remove('is-active');
        });
        opt.classList.add('is-active');
        var triggerLabel = dropdown.querySelector('[data-dropdown-label]');
        if (triggerLabel) triggerLabel.textContent = opt.getAttribute('data-value');
        dropdown.classList.remove('is-open');
      }
      if (picker) {
        var label = picker.querySelector('[data-selected-value]');
        if (label) label.textContent = opt.getAttribute('data-value');
      }
      updateVariant();
      return;
    }

    if (!e.target.closest('.variant-dropdown')) {
      document.querySelectorAll('.variant-dropdown.is-open').forEach(function(d) {
        d.classList.remove('is-open');
      });
    }
  });

  /* ===========================
     QUANTITY SELECTOR
     =========================== */
  document.querySelectorAll('.quantity-selector').forEach(function(selector) {
    var input = selector.querySelector('.quantity-selector__input');
    var minus = selector.querySelector('[data-qty-minus]');
    var plus = selector.querySelector('[data-qty-plus]');

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* ===========================
     SLIDESHOW HERO
     =========================== */
  function initSlideshow() {
    var section = document.querySelector('[data-slideshow]');
    if (!section) return;

    var slides = section.querySelectorAll('[data-slide-index]');
    if (slides.length <= 1) return;

    var dots = section.querySelectorAll('[data-slide-dot]');
    var current = 0;
    var total = slides.length;
    var autoplay = section.closest('section') || section;
    var autoplaySpeed = 6000;
    var timer = null;

    /* Read autoplay settings from the section element's parent schema data */
    if (section.dataset.autoplaySpeed) {
      autoplaySpeed = parseInt(section.dataset.autoplaySpeed) * 1000;
    }

    function goToSlide(index) {
      if (index === current) return;
      slides[current].classList.remove('hero__slide--active');
      if (dots[current]) dots[current].classList.remove('hero__dot--active');

      /* Pause video on old slide */
      var oldVideo = slides[current].querySelector('video');
      if (oldVideo) oldVideo.pause();

      current = (index + total) % total;

      slides[current].classList.add('hero__slide--active');
      if (dots[current]) dots[current].classList.add('hero__dot--active');

      /* Play video on new slide */
      var newVideo = slides[current].querySelector('video');
      if (newVideo) newVideo.play();

      resetTimer();
    }

    function nextSlide() { goToSlide(current + 1); }
    function prevSlide() { goToSlide(current - 1); }

    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(nextSlide, autoplaySpeed);
    }

    /* Dot navigation */
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.slideDot));
      });
    });

    /* Arrow navigation */
    var prevBtn = section.querySelector('[data-slide-prev]');
    var nextBtn = section.querySelector('[data-slide-next]');
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);

    /* Touch/swipe support */
    var touchStartX = 0;
    var touchEndX = 0;

    section.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    section.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) nextSlide();
        else prevSlide();
      }
    }, { passive: true });

    /* Start autoplay */
    resetTimer();

    /* Pause on hover */
    section.addEventListener('mouseenter', function() {
      if (timer) clearInterval(timer);
    });
    section.addEventListener('mouseleave', function() {
      resetTimer();
    });
  }

  initSlideshow();

  /* ===========================
     DESKTOP GALLERY SLIDER
     =========================== */
  (function() {
    var slider = document.querySelector('[data-desktop-slider]');
    if (!slider) return;
    var slides = slider.children;
    if (slides.length <= 1) return;
    var prevBtn = document.querySelector('[data-desktop-prev]');
    var nextBtn = document.querySelector('[data-desktop-next]');
    var counter = document.querySelector('[data-desktop-counter]');
    var currentIndex = 0;
    var total = slides.length;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      currentIndex = index;
      slides[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + total;
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var slideWidth = slides[0].offsetWidth;
        var newIndex = Math.round(slider.scrollLeft / slideWidth);
        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          if (counter) counter.textContent = (currentIndex + 1) + ' / ' + total;
        }
      }, 10);
    }, { passive: true });
  })();

  /* ===========================
     CART NOTE TOGGLE
     =========================== */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-note-toggle]');
    if (!toggle) return;
    toggle.classList.toggle('is-open');
    var field = toggle.parentElement.querySelector('[data-note-field]');
    if (field) {
      field.style.display = field.style.display === 'none' ? 'block' : 'none';
    }
  });

  document.addEventListener('change', function(e) {
    var textarea = e.target.closest('[data-cart-note]');
    if (!textarea) return;
    var routes = getRoutes();
    fetch(routes.cart_url + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: textarea.value })
    });
  });

  /* ===========================
     SCROLL REVEAL ANIMATIONS
     =========================== */
  function initReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    reveals.forEach(function(el) {
      observer.observe(el);
    });
  }

  initReveal();

  /* ===========================
     ADD TO CART FORMS
     =========================== */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = parseInt(formData.get('quantity')) || 1;

      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = t('adding', 'Adding...');
      }

      window.MaisonNoire.addToCart(variantId, quantity)
        .then(function() {
          if (btn) {
            btn.textContent = t('added', 'Added');
            setTimeout(function() {
              btn.disabled = false;
              btn.textContent = originalText || (btn.getAttribute('data-add-text') || t('addToCart', 'Add to Bag'));
            }, 1500);
          }
        })
        .catch(function() {
          if (btn) {
            btn.disabled = false;
            btn.textContent = originalText || (btn.getAttribute('data-add-text') || t('addToCart', 'Add to Bag'));
          }
        });
    });
  });

  /* ===========================
     SIZING CHART MODAL
     =========================== */
  document.querySelectorAll('[data-sizing-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var modal = this.closest('[data-sticky-info], .product-info').querySelector('[data-sizing-modal]');
      if (!modal) modal = document.querySelector('[data-sizing-modal]');
      if (modal) {
        modal.style.display = 'flex';
        setTimeout(function() { modal.classList.add('is-open'); }, 10);
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-sizing-close]').forEach(function(close) {
    close.addEventListener('click', function() {
      var modal = this.closest('[data-sizing-modal]');
      if (modal) {
        modal.classList.remove('is-open');
        setTimeout(function() { modal.style.display = 'none'; }, 300);
        document.body.style.overflow = '';
      }
    });
  });

  /* ===========================
     BUNDLE OFFER — IMAGE UPDATE ON VARIANT CHANGE
     =========================== */
  document.addEventListener('change', function(e) {
    var sel = e.target.closest('.bundle-variant-select');
    if (!sel) return;
    var productNum = sel.getAttribute('data-bundle-product');
    var variantsEl = document.querySelector('[data-bundle-variants-' + productNum + ']');
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch(err) { return; }

    var selects = document.querySelectorAll('.bundle-variant-select[data-bundle-product="' + productNum + '"]');
    var selectedOptions = [];
    selects.forEach(function(s) { selectedOptions.push(s.value); });

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (v.options[j] !== selectedOptions[j]) { match = false; break; }
      }
      if (match && v.image) {
        var imgContainer = document.querySelector('[data-bundle-img-' + productNum + ']');
        if (imgContainer) {
          var img = imgContainer.querySelector('img');
          if (img) img.src = v.image;
        }
        break;
      }
    }
  });

  /* ===========================
     STICKY ADD TO CART
     =========================== */
  (function() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (!stickyBar || !addBtn) return;

    var stickyAddBtn = stickyBar.querySelector('[data-sticky-add-btn]');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
        } else {
          stickyBar.classList.add('is-visible');
          stickyBar.style.display = 'block';
        }
      });
    }, { threshold: 0 });

    observer.observe(addBtn);

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() {
        var variantSelect = document.querySelector('[data-variant-select]');
        var variantId = variantSelect ? variantSelect.value : null;
        if (!variantId) return;

        var originalText = this.textContent;
        this.disabled = true;
        this.textContent = t('adding', 'Adding...');

        window.MaisonNoire.addToCart(parseInt(variantId), 1)
          .then(function() {
            stickyAddBtn.textContent = t('added', 'Added');
            setTimeout(function() {
              stickyAddBtn.disabled = false;
              stickyAddBtn.textContent = originalText;
            }, 1500);
          })
          .catch(function() {
            stickyAddBtn.disabled = false;
            stickyAddBtn.textContent = originalText;
          });
      });
    }
  })();

  /* ===========================
     SYNC VARIANT ID TO BUY BUTTONS FORM
     =========================== */
  (function() {
    var variantSelect = document.querySelector('[data-variant-select]');
    var hiddenInput = document.querySelector('[data-variant-id]');
    if (!variantSelect || !hiddenInput) return;

    variantSelect.addEventListener('change', function() {
      hiddenInput.value = this.value;
    });

    var mo = new MutationObserver(function() {
      hiddenInput.value = variantSelect.value;
    });
    mo.observe(variantSelect, { attributes: true, childList: true, subtree: true });
  })();

  /* ===========================
     MARQUEE DUPLICATE
     =========================== */
  document.querySelectorAll('.marquee__track').forEach(function(track) {
    var clone = track.innerHTML;
    track.innerHTML += clone;
  });

  /* ===========================
     IMAGE LAZY LOADING
     =========================== */
  if ('loading' in HTMLImageElement.prototype) {
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.src = img.dataset.src || img.src;
    });
  }

  /* ===========================
     COUNTDOWN TIMER
     =========================== */
  (function() {
    var countdowns = document.querySelectorAll('[data-countdown]');
    countdowns.forEach(function(el) {
      var hours = parseInt(el.getAttribute('data-countdown-hours')) || 2;
      var productId = el.getAttribute('data-countdown-product');
      var storageKey = 'countdown_' + productId;
      var endTime = localStorage.getItem(storageKey);
      if (!endTime || parseInt(endTime) < Date.now()) {
        endTime = Date.now() + (hours * 3600000);
        localStorage.setItem(storageKey, endTime);
      } else {
        endTime = parseInt(endTime);
      }
      var hoursEl = el.querySelector('[data-countdown-hours-display]');
      var minsEl = el.querySelector('[data-countdown-minutes-display]');
      var secsEl = el.querySelector('[data-countdown-seconds-display]');
      var expiredEl = el.querySelector('[data-countdown-expired]');
      var digitsEl = el.querySelector('.countdown__digits');
      var labelEl = el.querySelector('.countdown__label');
      function pad(n) { return n < 10 ? '0' + n : n; }
      function update() {
        var remaining = endTime - Date.now();
        if (remaining <= 0) {
          if (digitsEl) digitsEl.style.display = 'none';
          if (labelEl) labelEl.style.display = 'none';
          if (expiredEl) expiredEl.style.display = 'block';
          clearInterval(timer);
          return;
        }
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minsEl) minsEl.textContent = pad(m);
        if (secsEl) secsEl.textContent = pad(s);
      }
      update();
      var timer = setInterval(update, 1000);
    });
  })();

  /* ===========================
     BACK TO TOP BUTTON
     =========================== */
  (function() {
    var btn = document.querySelector('.back-to-top');
    if (!btn) return;
    window.addEventListener('scroll', function() {
      if (window.scrollY > 500) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }, { passive: true });
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  } // end init

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
